// extracted by mini-css-extract-plugin
export var icon = "TextWithIcon-module--icon--+HtFv";